module.exports = __webpack_public_path__ + "img/solution_villa_sys.efd98450.jpg";